<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formTransportInvoice">
      <div class="ps-2 pe-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
            <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
          </div>
          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
              (onClick)="delete()"></app-custom-button>

            <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
              [severity]="'success'" [variant]="undefined" (onClick)="createNewRegister()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="transportInvoiceContract.userNameCreate"
              [createDate]="transportInvoiceContract.createDate"
              [userNameUpdate]="transportInvoiceContract.userNameUpdate"
              [updateDate]="transportInvoiceContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-12">
          <div class="row">
            <div class="col-lg-3 col-md-4 col-sm-6 col-12">
              <app-custom-autocomplete formControlName="providerId" [labelText]="'Proveedor'" [list]="listProviders"
                [required]="true" [recovery]="true" (onChangeSelect)="onProviderChange($event)">
              </app-custom-autocomplete>
            </div>
            <div class="col-lg-1 col-md-4 col-sm-6 col-12">
              <app-custom-input-text formControlName="documentNumber" [labelText]="'Factura'" [required]="true"
                [recovery]="true" (onChangeTextOnBlur)="getTransportInvoiceByKeys()"
                [maxLength]="15"></app-custom-input-text>
            </div>
            <div class="col-lg-1 col-md-4 col-sm-6 col-12">
              <app-custom-datepicker formControlName="dateTransportInvoice" [labelText]="'Fecha'" [required]="true">
              </app-custom-datepicker>
            </div>
            <div class="col-lg-1 col-md-3 col-sm-6 col-12">
              <app-custom-input-decimal formControlName="otherValues" [labelText]="'Valor Otros'" [required]="true">
              </app-custom-input-decimal>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 col-12">
              <app-custom-input-text formControlName="observation" [labelText]="'Observación'" [maxLength]="250">
              </app-custom-input-text>
            </div>
            <div class="col-lg-1 col-md-2 col-sm-2 col-10">
              <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateTransportInvoice">
              </app-custom-tag>
            </div>
            <div class="col field-button mt-2 d-flex align-items-end">
              <app-custom-button [title]="titleState" [icon]="'pi pi-undo'" [severity]="'primary'"
                (onClick)="changeStateTransportInvoice()">
              </app-custom-button>
            </div>

            <div class="col-lg-12 col-md-12 col-sm-9 col-12 d-flex align-items-end justify-content-end mt-2">
              <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                [disabled]="disabledForm" (onClick)="send()">
              </app-custom-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="row mt-3">
    <div class="col-12">
      <app-transport-invoice-detail [transportInvoiceId]="transportInvoiceId"
        [providerId]="formTransportInvoice.get('providerId')?.value" [disabledDetail]="disabledForm"
        [permissionUpdatable]="permissionUpdatable" (emitQuantityDetails)="getQuantityDetails($event)">
      </app-transport-invoice-detail>
    </div>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>